// extracted by mini-css-extract-plugin
export default {"parentClass":"servicestable_parentClass__sePZa","lv0":"servicestable_lv0__tmbi9","lv1":"servicestable_lv1__3hsyw"};